const test = [
  {
    id: "1",
    img: "https://www.zindagitrust.org/img/sections/3.jpg",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis, perspiciatis quas ab veniam eius quos?",
    price: 100,
  },
  {
    id: "2",
    img: "https://www.zindagitrust.org/img/sections/1n.jpg",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis, perspiciatis quas ab veniam eius quos?",
    price: 100,
  },
  {
    id: "3",
    img: "https://www.zindagitrust.org/img/sections/review.jpg",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis, perspiciatis quas ab veniam eius quos?",
    price: 100,
  },
  {
    id: "4",
    img: "https://pbs.twimg.com/media/E_ZLRbzUUAA6LR_.jpg:large",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis, perspiciatis quas ab veniam eius quos?",
    price: 100,
  },
  {
    id: "5",
    img: "https://live.staticflickr.com/1385/1117178912_2b41e8bbf8_b.jpg",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis, perspiciatis quas ab veniam eius quos?",
    price: 100,
  },
  {
    id: "6",
    img: "https://pbs.twimg.com/media/E_ZLRbzUUAA6LR_.jpg:large",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis, perspiciatis quas ab veniam eius quos?",
    price: 100,
  },
];

export default test;
